import { css } from '@app/styled';
import { outline } from '@app/styles';

const outlineReset = css`
    // prevent outline showing on click
    [tabindex],
    button,
    a,
    input {
        outline: none;
    }

    [data-type='themeProvider'],
    .louis-portal {
        [tabindex],
        button,
        a,
        input {
            &:focus-visible {
                ${outline}
            }
        }
    }
`;

export default outlineReset;
